<template>
  <router-view></router-view>
</template>

<script>
export default {
    data() {
        return {
            version: '0.9.0'
        }
    },
    created() {
        console.log(this.version);
    }
}
</script>

<style>
</style>
